<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('DriverManagement.driverNum')">
                    <el-input
                      size="mini"
                      v-model="formInline.driverNum"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.name')">
                    <el-input
                      size="mini"
                      v-model="formInline.name"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.authorizes')">
                    <el-input-number
                      size="mini"
                      v-model="formInline.authorizeCountLower"
                      controls-position="right"
                      :min="0"
                      :max="10000"
                    ></el-input-number>
                    <span>{{$t('DriverManagement.to')}}</span>
                    <el-input-number
                      size="mini"
                      v-model="formInline.authorizeCountUpper"
                      controls-position="right"
                      :min="0"
                      :max="10000"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('DRIVERAUTHORIZATIONMANAGEMENT_ADD')"
                  type="text"
                  @click="addSimple"
                  :disabled="selected.length != 1"
                  >{{$t('DriverManagement.btn.addAuthorize')}}</el-button
                >
                <el-button v-if="isPrimaryKey('DRIVERAUTHORIZATIONMANAGEMENT_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="$t('DriverManagement.btn.addAuthorize')"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="fingerGroup"
            :label="$t('DriverManagement.fingerGroup')+':'"
            :label-width="formLabelWidth"
            v-if="isShow"
          >
            <el-input
              disabled
              v-model="form.fingerGroup"
              :placeholder="$t('DriverManagement.form.terminalId')"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="driverNum"
            :label="$t('DriverManagement.driverNum')+':'"
            :label-width="formLabelWidth"
            v-if="isShow"
          >
            <el-input
              disabled
              v-model="form.driverNum"
              :placeholder="$t('DriverManagement.form.driverNumber')"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="driverName"
            :label="$t('DriverManagement.name')+':'"
            :label-width="formLabelWidth"
            v-if="isShow"
          >
            <el-input
              disabled
              v-model="form.driverName"
              :placeholder="$t('DriverManagement.form.driverName')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.authorizePower')+':'"
            :label-width="formLabelWidth"
            prop="authType"
          >
            <el-select
              v-model="form.authType"
              :placeholder="$t('DriverManagement.form.authorizePower')"
            >
              <el-option :label="$t('DriverManagement.normalAuthorize')" value="1"></el-option>
              <el-option :label="$t('DriverManagement.adminAuthorize')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="terminalType"
            :label="$t('DriverManagement.terminalType')+':'"
            :label-width="formLabelWidth"
            v-if="isShow"
          >
            <el-select
              v-model="form.terminalType"
              :placeholder="$t('DriverManagement.terminalType')"
              filterable
            >
              <el-option
                v-for="item in terminalList"
                :key="item.id"
                :label="item.terminalType"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('DriverManagement.choseTerminal')+':'"
            :label-width="formLabelWidth"
            prop="terminalIds"
            v-if="isShow"
          >
            <el-input
              disabled
              class="fuInput"
              v-model="form.terminalIds"
              placeholder=""
            ></el-input>
            <el-button
              class="fuButton"
              size="small"
              icon="el-icon-plus"
              @click="getCarInfo"
              >{{$t('DriverManagement.choseTerminal')}}</el-button
            >
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        :title="$t('DriverManagement.addTermianlSetting')"
        :visible.sync="dialogVisibleTransfer"
        width="1200px"
        :before-close="handleClose"
        class="addDialong"
        :close-on-click-modal="false"
      >
        <span><i-Terminal v-if="delTransfer" ref="driverTransfer" @postParam="postParam" :paramsData="paramsData" :id="id"></i-Terminal></span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisibleTransfer = false"
            >{{$t('common.btn.cancel')}}</el-button
          >
          <el-button size="small" type="primary" @click="assignment"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        width="1200px"
        :before-close="closeOperateDia"
        class="tableDialong"
        :title="$t('common.btn.operate')"
        :visible.sync="dialogOperateFormVisible"
        :close-on-click-modal="false"
      >
        <div class="zMsgSearch">
          <el-form :inline="true" :model="formTable" class="demo-form-inline">
            <el-form-item :label="$t('DriverManagement.carId')">
              <el-input
                size="mini"
                v-model="formTable.carId"
                :placeholder="$t('common.searchTip')"
                style="width: 150px"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('DriverManagement.terminalId')">
              <el-input
                size="mini"
                v-model="formTable.terminalId"
                :placeholder="$t('common.searchTip')"
                style="width: 150px"
                class="input-with-select"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                size="mini"
                type="primary"
                @click="Search"
                class="btn-chaxun"
                >{{$t('common.btn.search')}}</el-button
              >
              <el-button size="mini" @click="Clear" class="btn-del"
                >{{$t('common.btn.cancel')}}</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="zMsgBtn">
          <el-button type="text" @click="down">{{$t('common.btn.download')}}</el-button>
        </div>
        <div class="zMsgTable">
          <i-table
            :list="authorizeList"
            :height="authorizeHeight"
            ref="authorizeTable"
            @handleSelectionChange="handleAuthorizeChange"
            :options="option"
            :columns="authorizeColumns"
            :operates="authorizeOperates"
          ></i-table>
          <IPagination
            ref="AuthorizePage"
            @PageFun="changeAuthorizeSize"
          ></IPagination>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DriverAuthorizationManagement from "./DriverAuthorizationManagement.js";
export default DriverAuthorizationManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>

